enum FlexActivityStepType {
  VALIDATION = 'VALIDATION',
  CREATE_INVESTMENTMANDATE = 'CREATE_INVESTMENTMANDATE',
  CREATE_AGREEMENT_ID = 'CREATE_AGREEMENT_ID',
  UNDEFINED = 'UNDEFINED',
}

export default FlexActivityStepType;
